module.exports = __webpack_public_path__ + "img/sq5.13ab4b27.png";